module.exports = __webpack_public_path__ + "img/format_list_bulleted.d72eaa78.svg";